export default "__VITE_ASSET__c49cc28b__"